import { useState } from "react";
import { ghostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { QcPhotoViewer } from "@/components/manufacturing/qc/QcPhotoViewer";
import type { QcQueuedPhoto } from "@/lib/manufacturing/qcPhotoQueue";

function statusLabel(status: QcQueuedPhoto["status"]) {
  if (status === "sending") return "sending";
  if (status === "failed") return "failed";
  return "waiting";
}

export function QcLocalPhotoRows({
  photos,
  savedCount,
  disabled,
  onRemove,
  onRetry,
}: {
  photos: readonly QcQueuedPhoto[];
  savedCount: number;
  disabled: boolean;
  onRemove: (id: string) => void;
  onRetry: (id: string) => void;
}) {
  const [view, setView] = useState<{ url: string; title: string } | null>(null);
  if (photos.length === 0) return null;
  return (
    <>
      <ul className="space-y-1 text-sm text-gray-900 dark:text-zinc-100">
        {photos.map((photo, index) => (
          <li key={photo.id} className="flex min-w-0 flex-wrap items-center gap-2">
            <span>
              {photo.kind === "pass" ? "Pass photo" : `Photo ${savedCount + index + 1}`} · {statusLabel(photo.status)}
            </span>
            <button
              type="button"
              className={ghostBtnClass}
              onClick={() => {
                const title = photo.kind === "pass" ? "Pass photo" : `Photo ${savedCount + index + 1}`;
                setView((current) => {
                  if (current) URL.revokeObjectURL(current.url);
                  return { url: URL.createObjectURL(photo.file), title };
                });
              }}
            >
              View
            </button>
            {photo.status === "failed" ? (
              <button type="button" className={ghostBtnClass} disabled={disabled} onClick={() => onRetry(photo.id)}>
                Retry
              </button>
            ) : null}
            <button type="button" className={ghostBtnClass} disabled={disabled || photo.status === "sending"} onClick={() => onRemove(photo.id)}>
              Remove
            </button>
          </li>
        ))}
      </ul>
      {view ? (
        <QcPhotoViewer
          urls={[view.url]}
          index={0}
          title={view.title}
          onClose={() => {
            URL.revokeObjectURL(view.url);
            setView(null);
          }}
        />
      ) : null}
    </>
  );
}
